import { render } from "./SectionContact.vue?vue&type=template&id=4db5f01e"
const script = {}
script.render = render

export default script